import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-MessageErrorDownload-popup',
  templateUrl: './messageErrorDownload-popup.component.html',
  styleUrls: ['./messageErrorDownload-popup.component.sass']
})
export class MessageErrorDownload implements OnInit {

  body: string;
  constructor() { }

  ngOnInit() {
  }

  public showBodyText(val){
    console.log("showBodyText");
    this.body = val;
    $('#downloadErrorModal').show();
  }

  modalClose(){
    $('#downloadErrorModal').hide();
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/modal-window/message-error-download-popup/messageErrorDownload-popup.component.ts